import {
  shell,
  page,
  form,
  auth,
  table,
  cardLayout,
  dialog,
  toolbar,
} from './tokens/layout.js';

export const layoutTokens = {
  shell,
  page,
  form,
  auth,
  table,
  cardLayout,
  dialog,
  toolbar,
} as const;
